<template>
  <SoDialog
    v-model="value"
    card-title="Smart Meter Tips"
    data-testid="meter-tips-modal"
  >
    <section v-if="hasSmets1">
      <h5>Smets 1</h5>
      <ul class="meter-tips__list">
        <li class="meter-tips__list--heading">Receiving Reads:</li>
      </ul>
      <p class="mb-6">
        Woken up SMETS 1 meters are not compatible with IHDs. Use canned
        response 'SMETS 1 Compatibility' or check out the help page here
        <SoLink
          text="Customer thinks their meter is faulty"
          href="https://home.so.energy/posts/2119699-ihd-troubleshooting-step-by-step"
        />
      </p>

      <ul class="meter-tips__list">
        <li class="meter-tips__list--heading">Never Received Smart Reads:</li>
      </ul>
      <p class="mb-6">
        We will wake up all SMETS 1 meters as soon as we can. We are just
        waiting on the DCC to switch these SMETS 1 meters to the new
        communications network.<br />
        Use canned response 'Metering - SMETS 1 not woken up'
      </p>

      <ul class="meter-tips__list">
        <li class="meter-tips__list--heading">
          Stopped Receiving Smart Reads:
        </li>
      </ul>
      <p class="mb-6">
        We have stopped receiving reads from this meter.
        <SoLink
          text="Fetch Smart Readings"
          @click="isFetchSmartReadsModalOpen = true"
        />
        to fetch smart meter read button This can take around 5 minutes to
        appear on meter read history. If you're unable to fetch a read, take a
        manual reading and escalate to Metering SCOA.
      </p>
    </section>

    <section v-if="hasSmets2">
      <h5>Smets 2</h5>
      <ul class="meter-tips__list">
        <li class="meter-tips__list--heading">Receiving Reads:</li>
      </ul>
      <div class="mb-6">
        The smart meter is connected and we have received smart meter reads.
        <ol class="meter-tips__ordered-list">
          <li>
            If the customer is having problems with their IHD check out the IHD
            Troubleshooting page.
          </li>
          <li>Send canned response 'Metering - IHD Troubleshooting'</li>
        </ol>
      </div>

      <ul class="meter-tips__list">
        <li class="meter-tips__list--heading">Never Received Smart Reads:</li>
      </ul>
      <div class="mb-6">
        We have never received smart reads from this meter. We need to
        commission the smart meter after the appointment. We can fix this
        remotely or by appointment.<br />
        <ol class="meter-tips__ordered-list">
          <li>Submit a manual read</li>
          <li>Escalate to Metering SCOA.</li>
        </ol>
      </div>

      <ul class="meter-tips__list">
        <li class="meter-tips__list--heading">
          Stopped Receiving Smart Reads:
        </li>
      </ul>
      <p class="mb-6">
        <SoLink
          text="Fetch Smart Readings"
          @click="isFetchSmartReadsModalOpen = true"
        />
        to fetch smart meter read button This can take around 5 minutes to
        appear on meter read history. If you're unable to fetch a read, take a
        manual reading and escalate to Metering SCOA.
      </p>

      <ul class="meter-tips__list">
        <li class="meter-tips__list--heading">Smets 2 Register:</li>
      </ul>
      <div class="mb-6">
        SMETS 2 register must be exactly (1) not (01) or (NONE).
        <ul class="meter-tips__list">
          <li>
            If a register is not (1) we will not be able to receive the meter
            reads.
          </li>
          <li>
            If you see a register for a SMETS2 meter that is not (1) please
            escalate to Billing SCOA and ask them to request correct MTDs from
            industry.
          </li>
        </ul>
      </div>
    </section>
  </SoDialog>
  <FetchSmartReadsModal v-model="isFetchSmartReadsModalOpen" />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { MeterpointService } from "@/services/MeterpointService"
  import SoDialog from "@/components/SoDialog.vue"
  import SoLink from "@/components/SoLink.vue"
  import FetchSmartReadsModal from "./FetchSmartReadsModal.vue"

  export default defineComponent({
    components: {
      SoDialog,
      SoLink,
      FetchSmartReadsModal,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
        required: true,
      },
    },
    emits: ["update:modelValue"],
    data() {
      return {
        current: useCurrentAccountStore(),
        MeterpointService,
        isFetchSmartReadsModalOpen: false,
      }
    },
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
      hasSmets1() {
        return this.checkMeterpointSmetType(false)
      },
      hasSmets2() {
        return this.checkMeterpointSmetType(true)
      },
    },
    methods: {
      checkMeterpointSmetType(checkForSmet2: boolean) {
        return MeterpointService.getForAccount(
          this.current.accountNumber,
        ).data.some((meterpoint) => meterpoint.hasSmets2 === checkForSmet2)
      },
    },
  })
</script>

<style scoped>
  a {
    color: rgb(var(--v-theme-primary));
    text-decoration: none;
  }

  .meter-tips__list {
    list-style-position: inside;
    margin-left: 12px;
  }

  .meter-tips__list--heading {
    font-size: 1.125rem;
    font-weight: 500;
    line-height: 1.65rem;
  }

  .meter-tips__ordered-list {
    list-style: lower-alpha;
    list-style-position: inside;
    margin-left: 24px;
  }
</style>
